export default __webpack_public_path__ + "static/media/megamenu-img.5758e8a7.png";